const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Las portadas subidas se guardan como ruta relativa (/api/images/...).
// Las imágenes antiguas con URL externa siguen funcionando igual.
export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND}${url}`;
  return url;
};

export default resolveImageUrl;
